import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  height: ', 'px;\n  justify-content: center;\n  width: ', 'px;\n  color: ', ';\n'], ['\n  align-items: center;\n  display: flex;\n  height: ', 'px;\n  justify-content: center;\n  width: ', 'px;\n  color: ', ';\n']);

import styled from 'styled-components';
import { colors, themed } from '@atlaskit/theme';
import { drawerBackIconSize } from '../../utils/drawer-style-variables';

var DrawerPrimaryIcon = styled.div(_templateObject, drawerBackIconSize, drawerBackIconSize, themed({ light: colors.N500, dark: colors.DN500 }));

DrawerPrimaryIcon.displayName = 'DrawerPrimaryIcon';
export default DrawerPrimaryIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/styled/DrawerPrimaryIcon.js
// module id = 721
// module chunks = 0